const Divider = theme => ({
	root: {
		borderTopColor: `${theme.colors.light.neutral.border} !important`,
	},
});

export {Divider};